export default __webpack_public_path__ + "static/article-finance-most-reliable-cars-51dda415bd6e670497500058ce2a3962.jpg";